import TraitValue from 'components/taxonomy/trait_value';

// This is a duplication of config/traits.yml. Eventually this should get auto-built
// server side.
const traitsConfig = [
  {
    uuid: 'c6639f61-8884-45e2-9f78-9f1de059700b',
    slug: 'operating-system',
    name: 'Operating System',
    values: [
      {
        uuid: '0504f1bc-5727-4c11-943b-21ae32d664fb',
        slug: 'osx',
        name: 'macOS',
      },
      {
        uuid: 'dfeffbaa-53a1-41e6-b8cf-e145b8dcd772',
        slug: 'windows',
        name: 'Windows',
      },
      {
        uuid: '45d3ae2e-ddfe-411b-9119-ac4a0f8ac823',
        slug: 'linux',
        name: 'Linux',
      },
      {
        uuid: 'cf42490e-2c88-42f0-9832-09ed1f67949c',
        slug: 'android',
        name: 'Android',
      },
      {
        uuid: 'a10f539f-21a0-4151-9674-a7eed02840ad',
        slug: 'ios',
        name: 'iOS',
      },
    ],
  },
  {
    uuid: '2ae386f1-7144-4d0c-b8aa-6caba14faa6f',
    slug: 'file-type',
    name: 'File Type',
    values: [
      {
        uuid: '7ff3a28d-a24f-489a-983a-a400dfcb6998',
        slug: 'vst',
        name: 'VST',
      },
      {
        uuid: 'b4eb7cdf-4a90-4301-8f6b-45419c8808f9',
        slug: 'aax',
        name: 'AAX',
      },
      {
        uuid: '47f96db7-5601-4992-99e5-06fcea081235',
        slug: 'au',
        name: 'AU',
      },
      {
        uuid: 'b686accd-0b6f-4dfe-8e34-149d33801712',
        slug: 'standalone',
        name: 'Standalone',
      },
      {
        uuid: 'cb32c864-6e21-4f21-95c8-97e186576e08',
        slug: 'preset',
        name: 'Preset',
      },
      {
        uuid: '554ec26c-8206-479c-a0ff-78b12053e5b2',
        slug: 'pdf',
        name: 'PDF',
      },
      {
        uuid: '346ae996-986a-44e1-9345-1d71ca17c855',
        slug: 'midi',
        name: 'MIDI',
      },
      {
        uuid: '44bb83d6-360b-451e-a14f-3c9b968f88c4',
        slug: 'wav',
        name: 'WAV',
      },
      {
        uuid: 'cd387a4e-8dde-417d-836f-c3927e8f3e51',
        slug: 'video',
        name: 'Video',
      },
      {
        uuid: '2cd73ea8-037f-4297-a2ed-8a21ed6d1242',
        slug: 'template',
        name: 'Template',
      },
      {
        uuid: '09b5d32e-fcfc-4b99-869f-6bc9ae0376e8',
        slug: 'driver',
        name: 'Driver',
      },
    ],
  },
];

class Trait {
  static all() {
    return traitsConfig.map(attrs => new Trait(attrs));
  }

  static findByUuid(uuid) {
    const attrs = traitsConfig.find(attr => attr.uuid === uuid);
    if (attrs) { return new Trait(attrs); }
    return null;
  }

  constructor(config) {
    this.uuid = config.uuid;
    this.slug = config.slug;
    this.name = config.slug;
    this.values = config.values.map(valueConfig => new TraitValue(this, valueConfig));
  }

  findValueBySlug(slug) {
    return this.values.find(value => value.slug === slug);
  }

  findValueByUuid(uuid) {
    return this.values.find(value => value.uuid === uuid);
  }
}

export default Trait;



// WEBPACK FOOTER //
// ./javascripts/components/taxonomy/trait.js